import React from 'react';
import styled,{css} from 'styled-components';
import { fontQuicksand} from './mixin';
import Image from '../loggedout/common/Image';
import SuperSaverImage from '~images/purchase/super_saver.png';
import { device } from "../../utils/responsive_utilities"
const InfoBadge = ({
  showSaving, 
  showSubjectNameOnSelectedTile, 
  subject,
  percentOff, 
  savePercentage,
  showMorePlans,
  showSuperSaverTag
  }) => {
  
  return (
    <>
      { (!!percentOff && showMorePlans) ? <Span showSaving={true}>Extra {percentOff}% off</Span> : 
      (showSaving && !percentOff) && <Span showSaving={false}>Save {savePercentage}%</Span> }
      {showSubjectNameOnSelectedTile && <Span showTitle={true} showSaving={true}>{subject.title}</Span>}
      {showSuperSaverTag && <Span showImage={showSuperSaverTag}><Image src={SuperSaverImage}/></Span>}
    </>
  )
}

export default InfoBadge;

const Span = styled.span`
  position: absolute;
  padding: 0 1rem 0.3rem;
  background-color: ${props=>props.showTitle ? '#3437A5' : (props.showImage ? "unset" : '#EB6D45')};
  top: ${props => props.showImage ? "-0.5rem" : "-0.1rem"};
  right: 4rem;
  border-radius: 0 0 0.8rem 0.8rem;
  ${fontQuicksand(1.2, 1.6, 7)}
  img{
    width: 5.1rem;
    height: 4.22rem;
  }

  @media ${device.Phone}{
    img{
      width: 3.52rem;
      height: 3.33rem;
    }
    ${props=> props.showImage ? css`
        right: 2.5rem;
    ` : ""}
  }
`;
